import type {SocketContext} from './subscriptionTypes';

/**
 * Rearms THIS socket's idle timer. If the timer fires, the socket is considered
 * dead and is closed; the onclose handler then takes over reconnection.
 */
export const resetKeepAlive = (ctx: SocketContext) => {
  clearTimeout(ctx.keepAliveTimeout);
  ctx.keepAliveTimeout = setTimeout(() => {
    if (
      ctx.socket.readyState === WebSocket.OPEN ||
      ctx.socket.readyState === WebSocket.CONNECTING
    ) {
      ctx.socket.close();
    }
  }, ctx.keepAliveTimeoutMs);
};
